import moment from "moment";
import { observable, computed, toJS } from "mobx";

class ProfileResumeStore {
	constructor(rootStore, staticContext) {
		const categoryMap = {
			_educations: "education",
			_awards: "award",
			_publications: "publication",
			_affiliations: "affiliation",
			_workExperiences: "work_experience",
			_speakingEngagements: "speaking_engagement",
		};
		this.rootStore = rootStore;
		this._provider = staticContext.provider;
		this._resumes = staticContext.credentials?.filter(
			(l) => l.category?.toLowerCase() !== "license",
		);

		for (const [key, category] of Object.entries(categoryMap)) {
			this[key] = this._resumes.filter(
				(r) => r.category?.toLowerCase() === category,
			);
		}
	}

	@observable _educations = [];
	@computed get educations() {
		return toJS(this._educations);
	}
	get hasEducations() {
		return this.hasItems("educations");
	}

	@observable _workExperiences = [];
	@computed get workExperiences() {
		return toJS(this._workExperiences);
	}
	get hasWorkExperiences() {
		return this.hasItems("workExperiences");
	}

	@observable _awards = [];
	@computed get awards() {
		return toJS(this._awards);
	}
	get hasAwards() {
		return this.hasItems("awards");
	}

	@observable _affiliations = [];
	@computed get affiliations() {
		return toJS(this._affiliations);
	}
	get hasAffiliations() {
		return this.hasItems("affiliations");
	}

	@observable _publications = [];
	@computed get publications() {
		return toJS(this._publications);
	}
	get hasPublications() {
		return this.hasItems("publications");
	}

	@observable _resumes = [];
	@computed get resumes() {
		return toJS(this._resumes);
	}
	get hasResumes() {
		return this.hasItems("resumes");
	}

	@observable _provider = [];
	@computed get provider() {
		return toJS(this._provider);
	}

	@observable _speakingEngagements = [];
	@computed get speakingEngagements() {
		return toJS(this._speakingEngagements);
	}
	get hasSpeakingEngagements() {
		return this.hasItems("speakingEngagements");
	}

	hasItems(key) {
		return this[key].length > 0;
	}

	dateFormatString(date, format = "MM/DD/YYYY") {
		if (!date) return date;
		return moment.utc(date).format(format);
	}

	dateRangeString(from, to) {
		const fromYear = this.dateFormatString(from, "YYYY");
		const toYear = this.dateFormatString(to, "YYYY") || "present";
		let output = "";
		if (from) {
			output = output.concat(fromYear);
		}

		if (from && to) {
			output = output.concat(` – ${toYear}`);
		}

		return output;
	}
}

export default ProfileResumeStore;
